import React from "react";

import SearchFilter from "components/searchFilter";
import { API_FETCH_STATUS } from "constants/common";

import { getSearchTypeOptions } from "../utils/utils";

import styles from "./filters.scss";

const { search_filter_message } = styles;
const { LOADING } = API_FETCH_STATUS;

const Filters = ({ partyAggregationLevel, partySelectorState, setPartySelectorState, setSelectedParty }) => {
  const { searchType, searchValue } = partySelectorState;

  const handleSearchTypeChange = (value) => {
    setPartySelectorState({
      searchType: value,
      searchValue: "",
    });
  };

  const handleSearchValueChange = (value) => {
    setPartySelectorState({
      searchValue: value,
    });
  };

  return (
    <>
      <SearchFilter
        variant="compact"
        name="partySearch"
        searchType={searchType}
        searchValue={searchValue}
        searchTypeOptions={getSearchTypeOptions(partyAggregationLevel)}
        onSearchTypeChange={handleSearchTypeChange}
        onSearchValueChange={handleSearchValueChange}
        placeholder={`Enter ${searchType.displayName} here`}
      />
      {(searchValue.length === 1 || searchValue.length === 2) && (
        <div className={search_filter_message}>minimum 3 characters required</div>
      )}
    </>
  );
};

export default Filters;
